import React, { useState, useMemo } from "react";
import axios from 'axios';
import { ipAddress } from '../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import './login.css';

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function LoginPage() {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState(null);

  const dots = useMemo(() =>
    Array.from({ length: 20 }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 2}s`,
      animationDuration: `${3 + Math.random() * 2}s`,
    })), []);

  const showMessage = (msg, type = 'error') => {
    setMessage({ text: msg, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const handleSignIn = async (event) => {
    if (event) event.preventDefault();

    if (isNaN(phone.trim())) {
      showMessage('Phone number cannot contain text or symbols', 'error');
      return;
    }

    try {
      const response = await axios.post(`${ipAddress}/api/Auth/partner_login`, {
        phone: phone.trim(),
        password
      });
      const { token, _id } = response.data;
      localStorage.setItem('partnerId', _id);
      localStorage.setItem('partnerToken', token);
      localStorage.removeItem('waytrixToken');
      localStorage.removeItem('restoToken');
      showMessage('Sign-in successful!', 'success');
    } catch (error) {
      console.error('Error signing in:', error);
      const errorMessage = error.response?.data?.message || 'Please check your phone number and password.';
      showMessage(errorMessage, 'error');
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-overlay">
        <div className="login-bg-radial-1" />
        <div className="login-bg-radial-2" />
        <div className="login-bg-radial-3" />
        {dots.map((dot) => (
          <div
            key={dot.id}
            className="login-dot"
            style={{
              left: dot.left,
              top: dot.top,
              animationDelay: dot.animationDelay,
              animationDuration: dot.animationDuration,
            }}
          />
        ))}
      </div>

      {message && (
        <div className={`login-message ${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="login-form-container">
        <div className="login-card">
          <div className="login-card-header">
            <h3 className="login-card-title">Partner Sign In</h3>
            <p className="login-card-description">Enter your credentials to access your account</p>
          </div>
          <div className="login-card-content">
            <form onSubmit={handleSignIn} className="login-form">

              <div className="login-field">
                <label htmlFor="phone" className="login-label">Phone Number</label>
                <div className="login-input-wrapper">
                  <span className="login-input-icon"><PhoneIcon /></span>
                  <input
                    id="phone"
                    type="tel"
                    placeholder="Enter your phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="login-input"
                  />
                </div>
              </div>

              <div className="login-field">
                <label htmlFor="password" className="login-label">Password</label>
                <div className="login-input-wrapper">
                  <span className="login-input-icon"><LockIcon /></span>
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="login-input has-toggle"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="login-toggle-btn"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>

              <button type="submit" className="login-submit-btn">
                Sign In
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
